import type { Activity, ActivityType } from 'types';
import { ruleValueFields, validateRuleValues, type RuleValueSide } from 'modules/agreement/discountTree/form';
import { copyFactorPolicy } from 'modules/agreement/factorPolicy/form';
import { mediaTargetInvalidReason } from 'modules/agreement/discountTree';
import { isPathPrefix } from 'modules/supplier/supplier/components/ProductChainPicker';
import {
  type ProviderAgreementDiscountRuleInput,
  type ProviderAgreementDiscountRule,
  type ProviderTargetPath,
  type RuleFormValues,
} from './types';

export const ruleValueSides: readonly RuleValueSide[] = [
  { side: 'provider', discountField: (context) => context, policyField: 'factor_policy' },
];

export function formValuesFromRule(rule: ProviderAgreementDiscountRule): RuleFormValues {
  const { id: _id, order: _order, ...fields } = rule;
  return { ...fields, factor_policy: copyFactorPolicy(rule.factor_policy) };
}

export function validateRule(
  values: RuleFormValues,
  activities: readonly Activity[],
  targets: readonly ProviderTargetPath[],
  type: ActivityType,
) {
  const activity = values.target_activity;
  const errors = validateRuleValues(values, ruleValueFields(type, activity, ruleValueSides));
  if (values.target_path && mediaTargetInvalidReason(values.target_path, type)) {
    errors.target_path = `This target does not match ${type}. Select a compatible media target.`;
  }
  const matches = (path: ProviderAgreementDiscountRuleInput['target_path']) =>
    values.target_path != null && path.length === values.target_path.length && isPathPrefix(path, values.target_path);
  if (!errors.target_path && !targets.some(matches)) errors.target_path = 'Select a provided media target.';
  if (activity && (activity.kind !== 'MEDIA' || !activities.some((item) => item.id === activity.id)))
    errors.target_activity = 'Select a media activity.';
  return errors;
}
